import styled from 'styled-components'

// Wrapper
export const BreadcrumbWrapper = styled.div`
  /* Parent
  ------------------------------- */
  /* Childrens
  ------------------------------- */
  .breadcrumb-list {}

  /* Modifiers
  ------------------------------- */
  &.is-modifier-name {}

  /* Media queries
  ------------------------------- */
`
